import { useState } from "react";
import styles from "./SubjectCard.module.css";

const SubjectCard = ({ title, image, fontInfo, interactiveInfo, colors }) => {
  // Map titles to their corresponding images
  const getImagePath = () => {
    if (image) return image; // Use provided image if available

    const titleLower = title.toLowerCase();
    if (titleLower.includes("english")) {
      return "/search_wizards/Animation_title_guides_search_wizard_English.png";
    } else if (titleLower.includes("math")) {
      return "/search_wizards/Animation_title_guides_search_wizard_Math.png";
    } else if (titleLower.includes("science")) {
      return "/search_wizards/Animation_title_guides_search_wizard_Science.png";
    }
    // Default fallback
    return "/search_wizards/Animation_title_guides_search_wizard_English.png";
  };
  const [copiedColor, setCopiedColor] = useState(null);

  const handleColorClick = (color) => {
    navigator.clipboard.writeText(color).then(() => {
      setCopiedColor(color);
      setTimeout(() => setCopiedColor(null), 1500);
    });
  };

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        <img src={getImagePath()} alt={title} className={styles.image} />
      </div>
      <h3 className={styles.cardTitle}>{title}</h3>
      <p className={styles.fontInfo}>{fontInfo}</p>
      <p className={styles.interactiveInfo}>{interactiveInfo}</p>
      <div className={styles.colorPalette}>
        <span className={styles.colorLabel}>Colours:</span>
        {colors.map((color, index) => (
          <div
            key={index}
            className={styles.colorSwatch}
            style={{ backgroundColor: color }}
            onClick={() => handleColorClick(color)}
          >
            {color === copiedColor && (
              <span className={styles.copiedText}>Copied!</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubjectCard;
